import { KeyValuePipe, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbIconModule } from '@nebular/theme';
import { UtilityService } from 'src/app/core/services/utility.service';
import { Xliff } from 'src/app/models/drb-models/xliff';
import { translationLanguages } from '../../../../shared/constants/translation-languages';
import { StringTranslationComponent } from '../edit-xliff/string-translation/string-translation.component';

@Component({
  selector: 'app-view-xliff',
  templateUrl: './view-xliff.component.html',
  styleUrls: ['./view-xliff.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NgFor, StringTranslationComponent, KeyValuePipe]
})
export class ViewXliffComponent {
  public xliff: Xliff;
  public translationLanguages = translationLanguages;

  constructor(
    protected ref: NbDialogRef<ViewXliffComponent>,
    public utility: UtilityService
  ) {}

  public close() {
    this.ref.close();
  }

  public descOrder = (a, b) => {
    if (a.key < b.key) {
      return b.key;
    }
  };
}
